import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_IMPORT_ADS_BLOCK } from "@assets/svgs/ICON_IMPORT_ADS_BLOCK.svg";
import { Icon } from "@components/Icon";
import { COLOR_WHITE } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(43, 47, 50, 1);
  border-radius: 12px;
  overflow: hidden;
`;
const { REACT_APP_API_ENDPOINT } = process.env;

export const WidgetImage = ({ attribute }) => {
  const path = _.get(attribute, ["path"]);
  const fullPath = `${REACT_APP_API_ENDPOINT}/${path}`;

  return (
    <Container>
      {_.isNil(path) ? (
        <Icon width={"20%"} height={"20%"}>
          <ICON_IMPORT_ADS_BLOCK fill={COLOR_WHITE} />
        </Icon>
      ) : (
        <img
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
          src={fullPath}
          alt={"get-led"}
        />
      )}
    </Container>
  );
};
